import { type MessageCardProps } from "./MessageCard";
import { MessageCard } from "./MessageCard";
import { MessageCardProse } from "./MessageCardProse";
import { type MessageViewMode } from "@/lib/message-view-mode";

export interface MessageCardViewProps extends MessageCardProps {
  viewMode: MessageViewMode;
  /** When rendering in prose mode, whether the preceding filtered message
   *  is also a narrator message (affects paragraph flow). */
  isPreviousNarrator?: boolean;
  /** When rendering in prose mode, whether the next filtered message
   *  is also a narrator message (affects paragraph spacing). */
  isNextNarrator?: boolean;
}

/**
 * Single switch-point for message rendering. All message display goes through
 * this component so adding a new view mode only requires:
 *   1. Add the union member to `MessageViewMode`
 *   2. Create the renderer component
 *   3. Add a case here
 */
export function MessageCardView(props: MessageCardViewProps) {
  const { viewMode, isPreviousNarrator, isNextNarrator, ...rest } = props;

  switch (viewMode) {
    case "prose":
      return <MessageCardProse {...rest} isPreviousNarrator={isPreviousNarrator} isNextNarrator={isNextNarrator} />;
    case "chat":
    default:
      return <MessageCard {...rest} />;
  }
}
